import Vue from "vue";
import Vuetify from "vuetify/lib/framework";

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: "mdi",
  },
  theme: {
    themes: {
      light: {
        primary: "#2DB474",
        secondary: "#FFFFFF",
        anchor: "#2DB474",
        error: "#F44336",
      },
      dark: {
        primary: "#2DB474",
        secondary: "#121212",
        anchor: "#2DB474",
        error: "#F44336",
      },
    },
  },
});
